import { useQueryParam } from '@hooks/useQueryParams';
import { timeStampToDate } from '@utils/index';
import { useQuery } from 'react-query';

import { contractConstants } from 'modules/contract';

import { $api } from '../../../service/RequestService';
import { getContractsBody } from '../../../utils/helper/getSearchAndDownloadBodyAllTables';
import { ContractList } from '../../../utils/models/ContractList';
import { Pagination } from '../../../utils/models/Pagination';
import { SearchParamsContract } from '../Contract';
import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { ContractStatisticsType } from '../utils/models';

// get contracts list
export function useContracts(size: number, searchObj: SearchParamsContract) {
  return useQuery<Pagination<ContractList>>(
    [queryKeys.CONTRACT, searchObj.page, JSON.stringify(searchObj), size],
    async () => {
      const res = await $api.post(endPoints.CONTRACT_FILTER, getContractsBody(size, searchObj));

      const data: Pagination<ContractList> = res?.data?.data;

      return data
        ? {
            ...data,
            data: data?.data?.map(item => ({
              ...item,
              createdDate: timeStampToDate({ date: item?.createdDate, timeStamp: item?.createdTimestamp }),
              deletedDate: timeStampToDate({ date: item?.deletedDate!, timeStamp: item?.deletedTimestamp })
            }))
          }
        : data;
    }
  );
}

export function useContractStatistics(size: number) {
  const { searchParams } = useQueryParam();

  // @ts-expect-error
  delete searchParams?.page;

  const initial: ContractStatisticsType = {
    count: {
      total: 0,
      currencies: [],
      status: []
    },
    amountSum: {
      total: 0,
      currencies: [],
      status: []
    },
    areaSum: {
      total: 0,
      currencies: [],
      status: []
    }
  };

  const { data = initial, ...arg } = useQuery<ContractStatisticsType>(
    [contractConstants.queryKeys.STATISTICS, searchParams, size],
    async () => {
      const { data } = await $api.post('/v1/contract/filter/sum', getContractsBody(size, searchParams as never));

      return { ...(data?.data || initial) };
    },
    {
      retry: false,
      refetchOnWindowFocus: false
    }
  );

  return { ...data, ...arg };
}
